"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section-row-inventories"
  }, [_c("div", {
    staticClass: "inventories-header"
  }, [_vm.label ? _c("h4", {
    staticClass: "inventories-label"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.showAddButton && _vm.editable ? _c("b-button", {
    staticClass: "btn plant-nursery-primary-btn",
    attrs: {
      type: "is-primary",
      disabled: _vm.isDisabled
    },
    on: {
      click: _vm.addInventory
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.addButtonLabel))])]) : _vm._e()], 1), _vm._v(" "), !_vm.inventories.length ? _c("div", {
    staticClass: "empty-state"
  }, [_c("p", [_vm._v(_vm._s(_vm.emptyMessage))]), _vm._v(" "), _c("b-button", {
    attrs: {
      type: "is-link",
      size: "is-small",
      disabled: _vm.disabled
    },
    on: {
      click: _vm.addInventory
    }
  }, [_vm._v("\n      " + _vm._s(_vm.addFirstLabel) + "\n    ")])], 1) : _c("div", {
    staticClass: "inventories-list"
  }, _vm._l(_vm.inventories, function (inventory, index) {
    return _c("div", {
      key: index,
      staticClass: "inventory-item"
    }, [_c("div", {
      staticClass: "inventory-item-header"
    }, [_c("span", {
      staticClass: "inventory-item-title"
    }, [_vm._v(_vm._s(_vm.itemTitle) + " " + _vm._s(index + 1))]), _vm._v(" "), _vm.editable ? _c("b-button", {
      attrs: {
        type: "is-danger",
        size: "is-small",
        outlined: "",
        "icon-right": "delete",
        disabled: _vm.isDisabled || _vm.inventories.length === 1
      },
      on: {
        click: function click($event) {
          return _vm.removeInventory(index);
        }
      }
    }, [_vm._v("\n          Remover\n        ")]) : _vm._e()], 1), _vm._v(" "), _c("div", {
      staticClass: "inventory-item-content"
    }, [_c("b-field", {
      staticClass: "field-section",
      attrs: {
        label: _vm.sectionLabel
      }
    }, [_c("b-select", {
      attrs: {
        placeholder: _vm.sectionPlaceholder,
        disabled: _vm.isDisabled,
        loading: _vm.isLoading,
        expanded: ""
      },
      on: {
        input: function input($event) {
          return _vm.handleSectionChange(index);
        }
      },
      model: {
        value: inventory.sectionId,
        callback: function callback($$v) {
          _vm.$set(inventory, "sectionId", $$v);
        },
        expression: "inventory.sectionId"
      }
    }, [_c("option", {
      attrs: {
        disabled: ""
      },
      domProps: {
        value: null
      }
    }, [_vm._v("\n              " + _vm._s(_vm.sectionPlaceholder) + "\n            ")]), _vm._v(" "), _vm._l(_vm.sections, function (section) {
      return _c("option", {
        key: section.id,
        domProps: {
          value: section.id
        }
      }, [_vm._v("\n              " + _vm._s(section.name) + "\n            ")]);
    })], 2)], 1), _vm._v(" "), _c("b-field", {
      staticClass: "field-row",
      attrs: {
        label: _vm.rowLabel
      }
    }, [_c("b-select", {
      attrs: {
        placeholder: _vm.rowPlaceholder,
        disabled: !_vm.getAvailableRows(index).length || _vm.isDisabled,
        loading: _vm.isLoading,
        expanded: ""
      },
      on: {
        input: function input($event) {
          return _vm.handleRowChange(index);
        }
      },
      model: {
        value: inventory.rowId,
        callback: function callback($$v) {
          _vm.$set(inventory, "rowId", $$v);
        },
        expression: "inventory.rowId"
      }
    }, [_c("option", {
      attrs: {
        disabled: ""
      },
      domProps: {
        value: null
      }
    }, [_vm._v("\n              " + _vm._s(_vm.rowPlaceholder) + "\n            ")]), _vm._v(" "), _vm._l(_vm.getAvailableRows(index), function (row) {
      return _c("option", {
        key: row.id,
        attrs: {
          disabled: _vm.isRowDisabled(row.id, index)
        },
        domProps: {
          value: row.id
        }
      }, [_vm._v("\n              " + _vm._s(row.name) + "\n            ")]);
    })], 2)], 1), _vm._v(" "), _vm.showQuantity ? _c("b-field", {
      staticClass: "field-quantity",
      attrs: {
        label: _vm.quantityLabel
      }
    }, [_c("b-input", {
      attrs: {
        type: "number",
        placeholder: _vm.quantityPlaceholder,
        disabled: _vm.isDisabled || _vm.disabledQuantity,
        min: _vm.quantityMin,
        step: _vm.quantityStep
      },
      on: {
        input: function input($event) {
          return _vm.handleQuantityChange(index);
        }
      },
      model: {
        value: inventory.quantity,
        callback: function callback($$v) {
          _vm.$set(inventory, "quantity", _vm._n($$v));
        },
        expression: "inventory.quantity"
      }
    })], 1) : _vm._e()], 1)]);
  }), 0)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;